var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJiraWorkManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 980 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#2684ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 36.29,
    y1: 85.04,
    x2: 58.67,
    y2: 58.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.87,42.22h7.92V82.43c0,10.65-4.66,17.95-15.57,17.95a28.23,28.23,0,0,1-9.51-1.49V91.23a22.19,22.19,0,0,0,8.19,1.5c6.69,0,9-4,9-9.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.22,39.14a4.93,4.93,0,0,1,5.28,5.28,5.28,5.28,0,0,1-10.56,0A4.94,4.94,0,0,1,132.22,39.14ZM128.35,56h7.57v44h-7.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.75,100h-7.39V56h7.39v7.74c2.55-5.19,6.95-8.88,15.58-8.36v7.4c-9.68-1-15.58,1.93-15.58,11.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.79,92.11c-2.81,5.81-8.09,8.8-14.87,8.8-11.7,0-17.6-9.94-17.6-22.88,0-12.41,6.16-22.88,18.48-22.88,6.42,0,11.35,2.9,14,8.62V56h7.57v44h-7.57Zm-12.85,1.76c6.78,0,12.85-4.31,12.85-14.08V76.27c0-9.77-5.54-14.08-12-14.08-8.53,0-12.93,5.63-12.93,15.84C180.89,88.59,185.11,93.87,192.94,93.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.16,42.22h8.18l15,50.33,16.46-50.33h9.32l16.46,50.33,15.05-50.33h7.92L303.38,100H293.26l-16-49.37-16,49.37h-9.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.6,77.94c0-13.2,7.74-22.79,20.94-22.79s20.77,9.59,20.77,22.79-7.66,23-20.77,23S321.6,91.14,321.6,77.94Zm7.39,0c0,8.36,4.14,15.93,13.55,15.93s13.38-7.57,13.38-15.93-4.05-15.75-13.38-15.75S329,69.58,329,77.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.5,100h-7.39V56h7.39v7.74c2.55-5.19,6.95-8.88,15.58-8.36v7.4c-9.68-1-15.58,1.93-15.58,11.26Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.59,100V37.64h7.57v39L428.08,56h9.85L417.25,77.68,438.81,100H428.52L409.16,79.44V100Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.93,47V100H463V42.22h13.73l13.11,33.17,5.37,15.93,5.37-15.93,13.2-33.17h12.76V100h-7.92V47.58l-6.78,20.86L499.09,100h-7.66L478.85,68.44Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.05,92.11c-2.81,5.81-8.09,8.8-14.87,8.8-11.7,0-17.6-9.94-17.6-22.88,0-12.41,6.16-22.88,18.48-22.88,6.42,0,11.35,2.9,14,8.62V56h7.57v44h-7.57ZM556.2,93.87c6.78,0,12.85-4.31,12.85-14.08V76.27c0-9.77-5.54-14.08-12-14.08-8.53,0-12.93,5.63-12.93,15.84C544.15,88.59,548.37,93.87,556.2,93.87Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.46,100h-7.57V73.45c0-7.92-3.17-11.44-10.38-11.44-7,0-11.88,4.67-11.88,13.56V100h-7.57V56h7.57v7.22a15.41,15.41,0,0,1,13.9-8.1c10.12,0,15.93,7,15.93,19.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.85,92.11c-2.81,5.81-8.09,8.8-14.87,8.8-11.7,0-17.6-9.94-17.6-22.88,0-12.41,6.16-22.88,18.48-22.88,6.42,0,11.35,2.9,14,8.62V56h7.57v44h-7.57ZM653,93.87c6.78,0,12.85-4.31,12.85-14.08V76.27c0-9.77-5.54-14.08-12-14.08C645.35,62.19,641,67.82,641,78,641,88.59,645.17,93.87,653,93.87Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.51,92.11c-2.81,5.81-8.09,8.8-14.87,8.8C688,100.91,682.22,91,682.22,78c0-12.41,6.07-22.88,18.3-22.88,6.43,0,11.35,2.9,14,8.62V56h7.4v40c0,12.94-6.08,21.65-21.83,21.65a44.22,44.22,0,0,1-15.66-2.38V108a48.7,48.7,0,0,0,15.31,2.64c11,0,14.78-5.9,14.78-14.08Zm-12.84,1.76c6.77,0,12.84-4.31,12.84-14.08V76.27c0-9.77-5.54-14.08-12-14.08-8.54,0-12.94,5.63-12.94,15.84C689.61,88.59,693.83,93.87,701.67,93.87Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.38,100.91c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.76-22.79,13.56,0,19,9.42,19,22.79v3.43H738.36c1.06,7.48,5.9,12.32,16.28,12.32A38.94,38.94,0,0,0,768,91.32v7C764.41,100.21,758.87,100.91,754.38,100.91Zm-16.11-26h24.56C762.39,66.68,758.69,62,751.12,62,743.11,62,739.07,67.21,738.27,74.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.86,100h-7.57V73.45c0-7.92-3.17-11.44-10.39-11.44-7,0-11.87,4.67-11.87,13.56V100h-7.57V56H787v7.22a15.4,15.4,0,0,1,13.9-8.1c7.48,0,12.58,3.78,14.78,10.74,2.47-6.78,8.36-10.74,15.67-10.74,9.85,0,15.31,6.69,15.31,19.1V100h-7.57V75.57C839.12,66.5,836,62,828.74,62c-7,0-11.88,4.67-11.88,13.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.28,100.91c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H862.26c1.06,7.48,5.9,12.32,16.28,12.32a38.94,38.94,0,0,0,13.38-2.37v7C888.31,100.21,882.77,100.91,878.28,100.91Zm-16.1-26h24.55C886.29,66.68,882.59,62,875,62,867,62,863,67.21,862.18,74.86Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M940.76,100h-7.57V73.45C933.19,65.53,930,62,922.81,62c-7,0-11.88,4.67-11.88,13.56V100h-7.57V56h7.57v7.22a15.4,15.4,0,0,1,13.9-8.1c10.12,0,15.93,7,15.93,19.1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M968.74,92.9a24.31,24.31,0,0,0,4.75-.61v7.3a18.22,18.22,0,0,1-5.1.7c-9.42,0-14-5.54-14-13.72V63.07h-7.13V56h7.13V46.7h7.39V56h11.7v7h-11.7V86.39C961.79,90.26,964.08,92.9,968.74,92.9Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.42,41.87l-10.9,43C53.39,88.8,64.46,83.71,68.7,67l6.36-25.1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.68,100l10.9-43C32.7,53.1,21.64,58.19,17.4,74.93L11,100Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJiraWorkManagement);
export default __webpack_public_path__ + "static/media/logo-jira-work-management.20e49044494b76d185876da02cc014ed.svg";
export { ForwardRef as ReactComponent };